import React, { FC } from 'react';

import { FormattedList } from 'react-intl';

import { RegionalBroadcastTeam } from '../../../../types';

import { getNetworksListFromTeam } from './utils';

import { NetworkLogo, NetworkNames, NetworkSubtextContainer, RowContainer, Subtext } from './styles';

type BroadcastAreaRowProps = {
    team?: RegionalBroadcastTeam;
};

const BroadcastAreaRow: FC<BroadcastAreaRowProps> = ({ team }) => (
    <RowContainer>
        <NetworkLogo src={team?.logoUrls?.light} alt="" />
        <NetworkSubtextContainer>
            {getNetworksListFromTeam(team).length > 0 && (
                <NetworkNames>
                    <FormattedList style="short" type="unit" value={getNetworksListFromTeam(team)} />
                </NetworkNames>
            )}
            <Subtext>{team?.subtext?.default}</Subtext>
        </NetworkSubtextContainer>
    </RowContainer>
);

export default BroadcastAreaRow;
